import { TokenIcon } from '@ui/components/TokenIcon';
import { Text } from '@ui/lib/park/ui/text';
import { useTranslation } from 'next-i18next';
import { useContext } from 'react';
import { Flex, HStack } from 'styled-system/jsx';

import { ExchangeContext } from './Context';

export const TextFees = () => {
  const { t } = useTranslation();
  const { outputToken, outputAmount } = useContext(ExchangeContext);

  return (
    <Flex width="full" justifyContent="space-between" alignItems="center" py={1}>
      <Text color="greyWhite.white" fontWeight="light" fontSize="14px">
        {t("common.Fees:")}
      </Text>
      <HStack gap={1}>
        <Text fontSize="14px" fontWeight="normal" color="white">
          {outputAmount ? outputAmount : '0'}
        </Text>
      </HStack>
    </Flex>
  );
};